import React from "react";
import './RoomInfoDialog.scss';
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import Dialog from './ActionDialog';
import CloseIcon from '@mui/icons-material/Close';
import KeyIcon from '@mui/icons-material/Key';
import { useTranslation } from 'react-i18next';

const RoomInfoDialog = ({ open, onClose, roomId, isRandomRoom = false, deckCount, jokerPair, players, hostId, isHost, onRemoveClick }) => {
    const { t } = useTranslation();
    return (
        <Dialog fullWidth={true} open={open} onClose={onClose}>
            <DialogTitle sx={{ m: 0, p: 2 }} id="gameInfo-dialog-title">
                {t('roomInfo.roomInformation')}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <table className="table table-bordered border-stripe tbl-game-info">
                    <thead>
                        <tr>
                            <td className='title' colSpan={2}>{t('roomInfo.game')}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {!isRandomRoom && <tr>
                            <td className="column-title">{t('roomInfo.roomId')}</td>
                            <td>{roomId}</td>
                        </tr>}
                        <tr>
                            <td className="column-title">{t('roomInfo.deckCount')}</td>
                            <td>{deckCount}</td>
                        </tr>
                        <tr>
                            <td className="column-title">{t('roomInfo.jokerPair')}</td>
                            <td>{jokerPair}</td>
                        </tr>
                    </tbody>

                    {players && players?.length > 0 &&
                        <>
                            <thead>
                                <tr>
                                    <td className='title' colSpan={2}>{t('roomInfo.players')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {players?.map(player => {
                                    return (
                                        <tr key={player?.playerId}>
                                            <td className="column-title" colSpan={`${!isHost ? '2' : ''}`} style={{textAlign: `${!isHost ? 'center' : ''}`}}>
                                                {player.playerName} {player?.playerId === hostId && <KeyIcon sx={{color: '#e94560'}} />}
                                            </td>
                                            {isHost &&
                                            <td>{player?.playerId !== hostId && <button onClick={() => onRemoveClick(player)} type='button' className='btn-remove'>{t('common.remove')}</button>}</td>}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </>
                    }
                </table>

            </DialogContent>
        </Dialog>
    );
};

export default RoomInfoDialog;
